module.exports = __webpack_public_path__ + "img/Revoltosa carne,pollo o mixta.467a9690.jpeg";